import { useFormikContext } from "formik";
import { Ref, forwardRef } from "react";
import { CaptchaComponent, CaptchaComponentProp } from "./CaptchaComponent";

type Props = {
  onSuccess?();
  prop: CaptchaComponentProp;
  action?: string;
};

const InputCaptcha = forwardRef(function InputCaptcha(
  props: Props,
  ref: Ref<any>
) {
  const { setFieldValue } = useFormikContext();
  return (
    <CaptchaComponent
      onSuccess={(token) => {
        setFieldValue("captcha", token, false);
        if (typeof props.onSuccess !== "undefined") {
          props.onSuccess();
        }
      }}
      prop={props.prop}
      action={props.action}
    />
  );
});

export default InputCaptcha;
